import Link from "next/link";

export default function Breadcrumb({
  breadcrumbs = [],
  navClass = "",
  itemClass = "",
  activeClass = "",
}) {
  return (
    <nav
      className={`flex items-center gap-2 text-sm text-gray-600 mb-3 ${navClass}`}
    >
      {breadcrumbs.map((item, index) => {
        const isLast = index === breadcrumbs.length - 1;

        return (
          <div key={index} className="flex items-center gap-2">
            {/* {!isLast && item.url ? (
              <Link
                href={item.url}
                className={`hover:text-blue-600 transition-colors ${itemClass}`}
              >
                {item.label}
              </Link>
            ) : (
              <span className={`text-gray-900 font-medium ${activeClass}`}>
                {item.label}
              </span>
            )} */}

            <Link
              href={item.url}
              className={`hover:text-blue-600 transition-colors text-xs lg:text-sm ${itemClass}`}
            >
              {item.label}
            </Link>

            {!isLast && <span>/</span>}
          </div>
        );
      })}
    </nav>
  );
}
